import React, { useEffect } from "react";
import { useRechargeModel } from "./rechargeModel";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { YhBox } from "@/components/YhBox";
import { RechargeDataTable } from "./DataTable";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { Button, message } from "antd";
import { ApprovalDrawer } from "./ApprovalDrawer";
import { RechargeSearchBox } from "./SearchBox";

export const RechargeDataBox = () => {
    const {
        // dataSource,
        rechargeAmount,
        loadData,
        selectedRowKeys,
        selectedData,
        setApprovalDrawerVisible,
        onRevocation,
        billCustomerExport,
        setSearchParam
    } = useRechargeModel();

    useEffect(() => {
        loadData({ pageNum: 1 }, {});
        setSearchParam({})
    }, [])

    // useEffect(() => {
    //     let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
    //     const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
    //     setSelectedData(selectedData)
    // }, [selectedRowKeys]);

    const desc: IDescription[] = [
        {
            label: "充值总额",
            value: rechargeAmount?.toFixed(2) ?? '0.00',
            color: DescriptionColorEnum.green
        },
    ]

    const onApproval = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            if (selectedData?.status === 0) {
                setApprovalDrawerVisible(true);
            } else {
                message.error("该条记录不可审核!");
            }
        } else {
            message.error("请选择待审核记录!");
        }
    }

    const action = (
        <>
            <YhAuth resCode={ResourceAuthEnum.ACC_C_VW_CHARG_AUDIT}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onApproval}
                >
                    审核
                </Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.ACC_C_VW_CHARG_RETURN}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onRevocation}
                >
                    撤回
                </Button>
            </YhAuth>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={billCustomerExport}
            >
                导出
            </Button>
        </>
    );

    return (
        <>
            <RechargeSearchBox />
            <YhBox title={"充值记录"} action={action} descriptions={desc}>
                <RechargeDataTable />
            </YhBox>
            <ApprovalDrawer />
        </>
    )
}